import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { saveConditionGeofenceExit, saveConditionStateDescription } from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectGeofencesState
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/GeofencesCondition/SelectGeofencesState/SelectGeofencesState'
import SelectGeofencesStateIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/GeofencesCondition/SelectGeofencesState/SelectGeofencesState'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectGeofencesStateIOS) : withStyles(SelectGeofencesState)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    address, lat, lng, size,
  } = state.geofences.geofenceInfo
  const { isEditConditionMode } = state.scenes.currentSceneCreating
  return {
    isMobile,
    path,
    address,
    lat,
    lng,
    size,
    isEditConditionMode,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionGeofenceExit,
  saveConditionStateDescription,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectGeofencesStateEnhanced = enhance

export default withRouter(SelectGeofencesStateEnhanced)
